import { getLocale } from "../runtime";

const sv_trackordergeneralerror = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ett fel uppstod`
};

const trackordergeneralerror = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_trackordergeneralerror(inputs)
	return "trackOrderGeneralError";
};

export { trackordergeneralerror as "trackOrderGeneralError" };